module.exports = __webpack_public_path__ + "static/media/07_negro.148bcdae.svg";